import React from 'react';
interface GaugeChartProps {
  value: number;
  max: number;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  darkMode?: boolean;
  animated?: boolean;
}
export function GaugeChart({
  value,
  max,
  label,
  size = 'md',
  color = '#3b82f6',
  darkMode = false,
  animated = true
}: GaugeChartProps) {
  const percentage = value / max * 100;
  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  // Calculate the stroke dash offset based on percentage
  // We're using only 75% of the circle (270 degrees)
  const arcPercentage = percentage * 270 / 100;
  const dashOffset = circumference - circumference * arcPercentage / 360;
  const sizeClasses = {
    sm: 'h-24 w-24',
    md: 'h-32 w-32',
    lg: 'h-40 w-40'
  };
  const textColor = darkMode ? 'text-gray-300' : 'text-gray-800';
  const subTextColor = darkMode ? 'text-gray-400' : 'text-gray-500';
  const bgColor = darkMode ? 'bg-gray-800' : 'bg-white';
  return <div className={`${bgColor} rounded-lg p-4 flex flex-col items-center justify-center ${sizeClasses[size]}`} data-id="element-32">
      <div className="relative flex items-center justify-center" data-id="element-33">
        <svg className="transform -rotate-90" width="100%" height="100%" viewBox="0 0 100 100" data-id="element-34">
          {/* Background circle */}
          <circle cx="50" cy="50" r={radius} fill="none" stroke={darkMode ? '#374151' : '#e5e7eb'} strokeWidth="8" strokeDasharray={circumference} strokeDashoffset={circumference * 0.25} // Start at 0 degrees, end at 270 degrees
        data-id="element-35" />
          {/* Foreground circle */}
          <circle cx="50" cy="50" r={radius} fill="none" stroke={color} strokeWidth="8" strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={dashOffset + circumference * 0.25} className={animated ? 'transition-all duration-1000 ease-in-out' : ''} data-id="element-36" />
        </svg>
        {/* Value in the center */}
        <div className="absolute flex flex-col items-center" data-id="element-37">
          <span className={`text-xl font-bold ${textColor}`} data-id="element-38">{value}</span>
          {max && <span className={`text-xs ${subTextColor}`} data-id="element-39">/ {max}</span>}
        </div>
      </div>
      {label && <div className={`mt-2 text-sm font-medium ${textColor}`} data-id="element-40">{label}</div>}
    </div>;
}